import { render, staticRenderFns } from "./TestResultTable.vue?vue&type=template&id=cfa34646&scoped=true"
import script from "./TestResultTable.vue?vue&type=script&lang=ts"
export * from "./TestResultTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa34646",
  null
  
)

export default component.exports